import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { THEME_OPTIONS } from '@core/theme/theme-options';
import { ThemeService } from '@core/theme/theme.service';
import { ThemeClass } from '@core/theme/types';

@Component({
  selector: 'app-theme-picker-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>Themes</h2>

    <mat-dialog-content>
      <div class="theme-options">
        @for (option of themeOptions; track option.light.hex) {
          <div class="grid">
            <button
              (click)="changeTheme(option.light.class)"
              mat-button
              [style]="{
                backgroundColor: activeTheme() === option.light.class ? 'white' : option.light.hex,
                color: activeTheme() === option.light.class ? option.light.hex : 'white'
              }">
              <mat-icon>light_mode</mat-icon>
              {{ option.name }}
            </button>
            <button
              (click)="changeTheme(option.dark.class)"
              mat-stroked-button
              [style]="{
                backgroundColor: activeTheme() === option.dark.class ? 'white' : option.dark.hex,
                color: activeTheme() === option.dark.class ? option.dark.hex : 'white'
              }">
              <mat-icon>dark_mode</mat-icon>
              {{ option.name }}
            </button>
          </div>
        }
      </div>
    </mat-dialog-content>
  `,
  styles: `
    .theme-options {
      display: flex;
      gap: 0.5rem;
      flex-direction: column;
    }

    .grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0.5rem;
    }
  `,
})
export class ThemePickerDialogComponent {
  #themeService = inject(ThemeService);
  #dialogRef = inject(MatDialogRef<ThemePickerDialogComponent>);

  themeOptions = THEME_OPTIONS;
  activeTheme = this.#themeService.theme;

  changeTheme(newTheme: ThemeClass) {
    this.#themeService.changeTheme(newTheme);
    this.#dialogRef.close();
  }
}
